import gql from "graphql-tag";

export const GET_MY_NOTIFICATIONS_QUERY = gql`
  query GetMyNotifications($data: GetNotificationsInput!) {
    getMyNotifications(data: $data) {
      items {
        id
        type
        bookingId
        createdAt
        readAt
        booking {
          id
          fromDate
          toDate
          room {
            id
            number
            title
          }
          representative {
            id
            fullName
          }
        }
      }
      total
      hasMore
      extraData {
        unreadCount
      }
    }
  }
`;
